import React, { useEffect, useState } from 'react';
import '../../assets/css/popupAddCombination.css'
import {
    Container,
    Modal,

    Row,
    Form
} from "react-bootstrap";
import './popup.css';
import api from "../../seller-apis/api";
import { useAlert } from 'react-alert';
import variables from '../../Variables.json'
const PopupAddCombination = (props) => {
    const alert = useAlert();
    const [price, setPrice] = useState("");
    const [stock, setStock] = useState("");
    const [gst, setGst] = useState(0);
    // Toast States
    const [priceToastMsg, setPriceToastMsg] = useState("");
    const [stockToastMsg, setStockToastMsg] = useState("");
    // Combination handling
    const [curComurl, setcurComurl] = useState(undefined);
    const [combinations, setCombinations] = useState([])
    const [callbackMsg, setCallBackMsg] = useState(null)

    // SL-901
    const [viewMore, setViewMore] = useState(false);

    const handleClose = (cmd) => {
        setcurComurl(undefined)
        props.callbackResFun(callbackMsg, "combination",cmd);
        props.Popupvisibilityfun(false);
    };

    useEffect(() => {
        if (callbackMsg !== null) {
            props.callbackResFun(callbackMsg, "combination");
            props.Popupvisibilityfun(false);
        }
    }, [callbackMsg]);

    useEffect( async () => {
        setCallBackMsg(null)
        await getExprodReqs(props.detail.SKU);
        if (props?.detail?.combination?.length > 0) {
            let productCombinations = props?.detail?.combination;
            let vendor = props?.detail?.vendor;
            let exProductReqData = props?.detail?.exProductReqData;
            let combarry = [];
            let singleAttr = true;
            let combAttribs = [];
            if (
                productCombinations[0].value.length > 1
            ) {
                singleAttr = false;
            }
            combAttribs = productCombinations[0].value;
            productCombinations.map((pitem, pindex) => {
                if (pitem.active) {
                    let combVals = {}
                    if (!singleAttr) {
                        let com = "";
                        pitem.value.forEach((aitem, aindex) => {
                            com += combAttribs[aindex] + " - " + aitem;
                            com += aindex === pitem.value.length - 1 ? "" : ", ";
                        });
                        combVals = {
                            com: com,
                            price: "",
                            url: pitem.url,
                            tmpSts: pitem.tmpSts,
                            stock: ""
                        }
                    } else {
                        combVals = {
                            com: combAttribs[0] + " - " + pitem.value[0],
                            price: "",
                            url: pitem.url,
                            tmpSts: pitem.tmpSts,
                            stock: ""
                        };
                    }
                    // check for those combinations which exproduct request sent SL-1143
                    const foundExProdReq = exProductReqData?.filter((item) => item?.combination?.url === pitem.url)
                    if (foundExProdReq?.length > 0) {
                        return;
                    }
                    // const foundVendorComb = vendor?.combination?.filter((item) => item.url === pitem.url)
                    // if (foundVendorComb?.length > 0) {
                    //     return;
                    //     // combVals["price"] = foundVendorComb[0]?.purchase_price;
                    //     // combVals["stock"] = foundVendorComb[0]?.stock;
                    // }
                    combarry.length === 0 && setcurComurl(pitem?.url);
                    combarry.push(combVals)
                }
            })
            setCombinations(combarry)
        }
    }, [])

    // get exProd details for comb. this function workes when we upload a attribute data and close the popup and open again
    const getExprodReqs = (sku) => {
        let data = {
            "filter": {
                "SKU-Id": sku,
                vendors: {
                    $not: {
                        $elemMatch: {
                        vendor_id: localStorage.getItem("vendorId"),
                        combination: {$exists: true, $eq: []},
                        vActive: "ACTIVE",
                        }
                    }
                }
            }
        }
        api.product.searchProducts(data).then((res) => {
            const item = res.products[0];
            //  check if both balue not matched 
            if (item && combinations.length !== item?.exProductReqData.length) {
                if (props?.detail?.combination?.length > 0) {
                    let productCombinations = props?.detail?.combination;
                    let exProductReqData = item.exProductReqData;
                    let combarry = [];
                    let singleAttr = true;
                    let combAttribs = [];
                    if (
                        productCombinations[0].value.length > 1
                    ) {
                        singleAttr = false;
                    }
                    combAttribs = productCombinations[0].value;
                    productCombinations.map((pitem, pindex) => {
                        if (pitem.active) {
                            let combVals = {}
                            if (!singleAttr) {
                                let com = "";
                                pitem.value.forEach((aitem, aindex) => {
                                    com += combAttribs[aindex] + " - " + aitem;
                                    com += aindex === pitem.value.length - 1 ? "" : ", ";
                                });
                                combVals = {
                                    com: com,
                                    price: "",
                                    url: pitem.url,
                                    tmpSts: pitem.tmpSts,
                                    stock: ""
                                }
                            } else {
                                combVals = {
                                    com: combAttribs[0] + " - " + pitem.value[0],
                                    price: "",
                                    url: pitem.url,
                                    tmpSts: pitem.tmpSts,
                                    stock: ""
                                };
                            }
                            // check for those combinations which exproduct request sent SL-1143
                            const foundExProdReq = exProductReqData?.filter((item) => item?.combination?.url === pitem.url)
                            if (foundExProdReq?.length > 0) {
                                return;
                            }
                            combarry.length === 0 && setcurComurl(pitem?.url);
                            combarry.push(combVals)
                        }
                    })
                    setCombinations(combarry)
                }
            }
            
        }).catch(err => console.log(err))
    }

    const addProduct = async () => {
        setPriceToastMsg("");
        setStockToastMsg("");
        const isValid = validation();

        if (!isValid) return;

        let data;
        if (props.detail.taxClass == gst) {

            data = {
                _id: props.lead,
                purchase_price: price,
            };
        } else {

            data = {
                _id: props.lead,
                purchase_price: price,
                taxClass: gst,
            };
        }
        if (props.flag === "TV Catalogue") {
            data['receivedFrom'] = "tv_catalog";
        }
        let combination = {};
        combination["url"] = curComurl;
        combination["purchase_price"] = price;
        combination["stock"] = Number(stock)
        delete data["purchase_price"];
        data["combination"] = combination;
        data["addCombinationFlag"] = true;
        try {
            const res = await api.product.addToExProduct(data);
            handleSuccessfulSubmit()
        } catch (error) {
            console.log("Error in addProduct", error);
            alert.error("Error in adding product");
        }
    }

    const handleSuccessfulSubmit = () => {
        alert.success("Combination added successfully");
        let updatedCombinations = combinations.filter((item) => item.url !== curComurl);
        setCombinations(updatedCombinations);
        handleCombinationChange(updatedCombinations?.[0])
        if (updatedCombinations?.length === 0) {
            // handleClose("reload");
            setCallBackMsg("product added")

        }
    }

    const checkMinusInput = (e) => {
        if (e.code === "Minus") {
            e.preventDefault();
        }
    }

    const changeGST = (e) => {
        setGst(e.value);
    };

    const validation = () => {
        let isValid = true
        if (
            price === undefined ||
            price.trim() === "" ||
            price === "0" ||
            price === 0 ||
            price < 1 ||
            price.includes(".")
        ) {
            isValid = false;
            setPriceToastMsg(" Please enter a valid price!");
        }
        if (stock === undefined || stock.trim() === "" || stock === "0" || stock === 0 || stock < 1 || stock.includes(".")) {
            isValid = false
            setStockToastMsg(" Please enter a valid stock count!");
        }
        return isValid
    }

    // Handle Combination Change
    const handleCombinationChange = (item) => {
        setPriceToastMsg("")
        setStockToastMsg("")
        setPrice("")
        setStock("")
        setGst(0)
        setcurComurl(item?.url)
    }

    const ModalHeader = () =>
    (
        <>
            <div className="w-30">
                <div
                    className="catalog-img-border"
                    style={{
                        background: `url(
                    "https://s3.toolsvilla.com/${props.img}"
                  )`,
                    }}
                >
                </div>
            </div>
            <div className="w-70 align-self-start mt-2">
                <p className="product-name ff_pop fw-bold d-flex justify-contain-start">{props.productName}</p>
                <p className="sku mb-2 d-flex justify-contain-start">SKU - {props.detail.SKU}</p>
                {/* <h6 className="product-name ff_pop fw-bold d-flex justify-contain-start">Brand Name</h6> */}
                <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: props.detail.shortDescription }}></div>
                </div>
                 {viewMore && <div style={{ textAlign: 'left' }}><p className="fs-13">Description</p>
                    <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: props.detail.description }}></div>
                </div>}
                            <p style={{ cursor: "pointer", fontSize:"12px", color:"blue"}} onClick={() => setViewMore(!viewMore)}>{viewMore?"View Less":"View More"}</p>
            </div>
        </>
    )


    return (
        <Modal
            show={true}
            onHide={handleClose}
            className='popupCombinationModal'
            centered
        >
            <a class="close mt-1" onClick={() => {
                handleClose()
            }}>
                &times;
            </a>
            <Modal.Body className=" p_3px">

                <div className="d-flex header">
                    <ModalHeader />
                </div>


                <div className='d-flex mt-2'>
                    {/* Combination list */}
                    <div className='w-30 combination-list'>
                        <ul>
                            {combinations.map((item, index) => {
                                return (
                                    <li key={index} className={curComurl === item?.url ? 'active' : ""} onClick={(e) => handleCombinationChange(item)}>{item.com}</li>
                                )
                            })}
                        </ul>

                    </div>

                    {/* Form */}
                    <div className='w-70 input-area'>
                        <Row className="text-center mt-1">
                            <div className="fw-bold d-flex justify-contain-start">Add Price</div>
                            <div className="col-12 ">
                                <form className="">
                                    <label className="transfer-price-container">
                                        <p className="transfer-price ff_pop my-auto">
                                            Transfer Price (incl. {gst}% GST) :
                                        </p>
                                        <p className="position-relative">
                                            <input
                                                type="number"
                                                name="number"
                                                autocomplete="off"
                                                minLength="1"
                                                onKeyDown={checkMinusInput}
                                                value={price}
                                                required
                                                onChange={(e) => setPrice(e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                                className=" w-100 input-with-label"
                                            />
                                            <span class="rs-label">Rs</span>

                                        </p>
                                    </label>
                                    {priceToastMsg !== "" && <div
                                        className="toastAlert mb-2"
                                    >

                                        {priceToastMsg}
                                    </div>}
                                    <label className="gst-price-container">
                                        <p className="title-100">Select GST % : </p>
                                        <p className="gst-select">
                                            <Form.Select
                                                size="sm"
                                                className="pro_card_comb_box_invent"
                                                value={gst}
                                                onChange={(e) => changeGST(e.target)}
                                            >
                                                {variables?.variables?.gstValues.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item}>
                                                            {item}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </p>
                                    </label>
                                </form>
                            </div>
                        </Row>
                        <hr />

                        <Row className="text-center mt-1">
                            <div className="fw-bold d-flex justify-contain-start">Add Stock</div>
                            <div className="col-12 ">
                                <form className="">
                                    <label className="transfer-price-container">
                                        <p className="transfer-price ff_pop my-auto">
                                            Stock
                                        </p>
                                        <p className="position-relative">
                                            <input
                                                type="number"
                                                value={stock}
                                                name="number"
                                                autocomplete="off"
                                                minLength="1"
                                                onKeyDown={checkMinusInput}
                                                required
                                                onChange={(e) => setStock(e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                                className=" w-100 input-without-label"
                                            />


                                        </p>
                                    </label>
                                    {stockToastMsg !== "" && <div
                                        className="toastAlert"
                                    >

                                        {stockToastMsg}.
                                    </div>}
                                </form>
                            </div>
                        </Row>

                        <div className="justify-content-end d-flex-responsive">

                            <button
                                className="submit-btn"
                                onClick={() => addProduct()}
                            >
                                SUBMIT
                            </button>

                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default PopupAddCombination;